import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import ArrowRight from '../icons/ArrowRight';
import Download from '../icons/Download';
const StyledAnchor = styled.a `
    display: inline-flex;
    align-items: center;
    margin-left: auto;
    text-decoration: none;
    color: ${props => props.theme.secondary};
    transition: all 150ms ease-in-out;

    span {
        display: flex;
        margin-left: 10px;

        svg {
            transition: fill 150ms ease-in-out;
            fill: ${props => props.theme.secondary};
        }
    }
`;
function icon(action) {
    switch (action.type) {
        case 'blank':
            return _jsx(ArrowRight, {});
        case 'download':
            return _jsx(Download, {});
    }
}
const Action = ({ action }) => {
    const linkIcon = icon(action);
    return (_jsxs(StyledAnchor, { href: action.url, download: action.type === 'download', target: action.type === 'blank' ? '_blank' : '_self', children: [action.label, linkIcon && _jsx("span", { children: linkIcon })] }));
};
export default Action;
